const ItemGenerator = require('../../../game_items/ItemGenerator');
const MedTorsoe = require('../../../game_items/equipment/torsoe/MedTorsoe');
const MedBoots = require('../../../game_items/equipment/boots/MedBoots');
const Dagger = require('../../../game_items/equipment/weapon/Dagger');
const Bow = require('../../../game_items/equipment/off_hand/Bow');
const getMobEquipmenAssignmentFromBags = require('../mobs/getMobEquipmenAssignmentFromBags');

const Elf = (level, summoner) => {
  const handle = 'elf';
  const types = ['archer', 'elf', 'humanoid', 'poisonous', 'summoned'];
  const bags = [
    {
      value: {
        items: [
          ItemGenerator.getRandomItem(MedTorsoe, level / 10, level / 5),
          ItemGenerator.getRandomItem(MedBoots, level / 10, level / 5),
          ItemGenerator.getRandomItem(Dagger, level / 10, level / 5),
          ItemGenerator.getRandomItem(Bow, level / 10, level / 5),
        ].map((item) => ({ value: item })),
      },
    },
  ];
  const ai_priorities = ['dps_ranged', 'dps_close', 'interference', 'tank', 'support'];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'elf_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          poison_weapon: { handle: 'poison_weapon', level: bound_level * 2 },
          arrow_shot: { handle: 'arrow_shot', level: bound_level * 2 },
          range: { handle: 'range', level: bound_level * 2, passive: true },
          leap: { handle: 'leap', level: bound_level * 2 },
          quickness: {
            handle: 'quickness',
            level: bound_level * 2,
            passive: true,
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => {
      const { base, fromUpgrades, fromEquipment, fromConditions } = summoner.attributes;
      const summoner_learning =
        base.learning + fromUpgrades.learning + fromEquipment.learning + fromConditions.learning;
      return {
        learning: Math.round(5 + bound_level * 1.0 + summoner_learning * 0.2 + Math.random() * 2.1),
        perception: Math.round(
          8 + bound_level * 2.0 + summoner_learning * 0.4 + Math.random() * 2.1
        ),
        mana: Math.round(3 + bound_level * 1.0 + summoner_learning * 0.2 + Math.random() * 2.1),
        toughness: Math.round(
          4 + bound_level * 1.5 + summoner_learning * 0.3 + Math.random() * 2.1
        ),
        strength: Math.round(5 + bound_level * 1.0 + summoner_learning * 0.2 + Math.random() * 2.1),
        willpower: Math.round(
          1 + bound_level * 0.5 + summoner_learning * 0.1 + Math.random() * 2.1
        ),
        dexterity: Math.round(
          9 + bound_level * 2.0 + summoner_learning * 0.4 + Math.random() * 2.1
        ),
      };
    }).bind(null, level),
    getDefaultAIConfig: () => ai_priorities,
    getStarterEquipment: () => {},
    bags,
    build: {
      ai: {
        priorities: ai_priorities,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities: [
        { value: 'move' },
        { value: 'melee_attack' },
        { value: 'poison_weapon' },
        { value: 'arrow_shot' },
        { value: 'range' },
        { value: 'leap' },
        { value: 'quickness' },
      ],
      handle,
      level,
      team: summoner.team,
      types,
      unit: true,
    },
  };
};
module.exports = Elf;
